<template>
  <div>
    <v-data-table :headers="headers"
                  :loading="loading"
                  :items="hostingSshPrivateKeys">
      <v-progress-linear slot="progress" color="green" height="2" indeterminate></v-progress-linear>
      <template #item.actions="{ item }">
        <v-menu bottom offset-y min-width="180">
          <template v-slot:activator="{ on, attrs }">
            <gg-btn v-on="on" v-bind="attrs">
              Manage <v-icon right>mdi-chevron-down</v-icon>
            </gg-btn>
          </template>
          <v-list>
            <v-list-item @click="openModal('view', item)">
              <v-list-item-title>View/Download</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openModal('delete', item)">
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <delete-ssh-key-modal
      v-if="selectedSshKey"
      pub="0"
      :opened="modals.delete"
      :ssh-key="selectedSshKey"
      @close="closeModal('delete')"
      @key-deleted="reload"
    />
    <view-ssh-key-modal
      v-if="selectedSshKey"
      pub="0"
      :opened="modals.view"
      :ssh-key="selectedSshKey"
      @close="closeModal('view')"
    />
    <convert-to-ppk-modal
      v-if="selectedSshKey"
      :opened="modals.convert"
      :ssh-key="selectedSshKey"
      @close="closeModal('convert')"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteSshKeyModal from './DeleteSshKeyModal'
import ViewSshKeyModal from './ViewSshKeyModal'
import ConvertToPpkModal from './ConvertToPpkModal'

export default {
  name: 'PrivateKeysTable',
  components: {
    DeleteSshKeyModal,
    ViewSshKeyModal,
    ConvertToPpkModal,
  },
  props: {
    tableShouldBeReloaded: {
      type: Boolean,
      required: false,
    },
  },
  data () {
    return {
      loading: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false,
        }
      ],
      selectedSshKey: null,
      modals: {
        delete: false,
        view: false,
        convert: false,
      },
    }
  },
  computed: mapGetters(['hostingSshPrivateKeys', 'pagination']),
  methods: {
    ...mapActions(['loadHostingSshPrivateKeysList', 'reportError']),
    openModal (modal, ssh) {
      this.modals[modal] = true
      this.selectedSshKey = { ...ssh }
    },
    closeModal (modal) {
      this.modals[modal] = false
      this.selectedSshKey = null
    },
    reload () {
      this.loading = true
      this.loadHostingSshPrivateKeysList(this.$route.query.user).then(
        () => {
          this.loading = false
          this.$emit('table-reloaded', { privateTable: true })
        },
        error => {
          this.loading = false
          this.reportError(error)
        }
      )
    },
  },
  watch: {
    tableShouldBeReloaded (val) {
      if (val) {
        this.reload()
      }
    }
  },
  created () {
    this.reload()
  }
}
</script>
